module.exports = __webpack_public_path__ + "static/img/3d打印透明pc.5f680ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3d打印透明pc.png
// module id = 6Pb1
// module chunks = 2